<div class="empty-state" [class.page-mode]="pageMode">
  <div class="empty-state-icon">
    <lib-icon [icon]="icon" size="24"></lib-icon>
  </div>

  @if (title) {
    <span class="empty-state-title">{{ title }} </span>
  }
  @if (text) {
    <span class="empty-state-subtitle">{{ text }}</span>
  }
</div>